var stationDataListEntityCollection = null
function addStationDataList (params, viewer) {
  if (stationDataListEntityCollection) {
    removeStationDataList(viewer)
  }
  stationDataListEntityCollection = new Cesium.CustomDataSource('stationDataList')

  const BJ = {
    name: 'BJ',
    text: '北 京',
    lon: 121,
    lat: 41,
    height: 200000,
    width: 14000,
    // Cesium.Color.fromCssColorString('#67ADDF');
    color: '#00CC66'
  }

  const SH = {
    name: 'SH',
    text: '上 海',
    lon: 120,
    lat: 30,
    height: 100000,
    width: 14000,
    // Cesium.Color.fromCssColorString('#67ADDF');
    color: '#00CC66'
  }

  const dataList = params.data || [BJ, SH]
  const imgUrl = params.image || '../img/ring.png'
  dataList.forEach(data => {
    addStation(stationDataListEntityCollection, data, imgUrl)
  })

  viewer.dataSources.add(stationDataListEntityCollection)
  //  viewer.zoomTo(stationDataListEntityCollection)
  return stationDataListEntityCollection
}

function addStation (myEntityCollection, info, imageUrl) {
  const name = info.name
  const text = info.text
  const lon = info.lon
  const lat = info.lat
  const height = info.height
  const width = info.width
  // Cesium.Color.fromCssColorString('#67ADDF');
  const color = info.color

  var blueEllipse = {
    position: Cesium.Cartesian3.fromDegrees(lon, lat, 0.0),
    name: name,
    ellipse: {
      semiMinorAxis: width,
      semiMajorAxis: width,
      extrudedHeight: height,
      rotation: Cesium.Math.toRadians(45),
      material: Cesium.Color.fromCssColorString(color),

      // outline: true,
    }
  }
  myEntityCollection.entities.add(blueEllipse)

  const ringMaterial = new Cesium.ImageMaterialProperty({
    image: imageUrl,
    repeat: new Cesium.Cartesian2(1.0, 1.0),
    transparent: true,
    color: Cesium.Color.WHITE
  })

  // const whiteRing =
  // {
  //   position: Cesium.Cartesian3.fromDegrees(lon, lat, 0.0),
  //   ellipse: {
  //     semiMinorAxis: width + 23000,
  //     semiMajorAxis: width + 23000,
  //     material: Cesium.Color.GREEN,
  //     color: new Cesium.Color(1.0, 0.0, 0.0, 1.0),
  //     height: 0,
  //   }
  // }
  const widthMax = width / 20 * 176
  const whiteRingImg =
  {
    position: Cesium.Cartesian3.fromDegrees(lon, lat, 0.0),
    ellipse: {
      semiMinorAxis: widthMax,
      semiMajorAxis: widthMax,
      material: ringMaterial,
      //  color: new Cesium.Color(1.0, 0.0, 0.0, 1.0),
      //    height: 0,
    }
  }
  var r1 = widthMax / 2

  const whiteRingImg1 =
  {
    position: Cesium.Cartesian3.fromDegrees(lon, lat, 0.0),
    ellipse: {
      semiMinorAxis: new Cesium.CallbackProperty(function () {
        r1 = r1 + 250
        if (r1 >= widthMax) {
          r1 = widthMax / 2
        }
        return r1
      }, false),

      semiMajorAxis: new Cesium.CallbackProperty(function () {
        r1 = r1 + 250
        if (r1 >= widthMax) {
          r1 = widthMax / 2
        }
        return r1
      }, false),
      material: ringMaterial,
      //  color: new Cesium.Color(1.0, 0.0, 0.0, 1.0),
      //    height: 0,
    }
  }


  // myEntityCollection.entities.add(whiteRing)
  myEntityCollection.entities.add(whiteRingImg1)


  myEntityCollection.entities.add({
    position: Cesium.Cartesian3.fromDegrees(lon, lat, height),
    label: {
      text: text,
      font: '20px sans-serif',
      showBackground: false,
      color: Cesium.Color.fromCssColorString('#fff'),
      style: Cesium.LabelStyle.FILL_AND_OUTLINE,
      outlineWidth: 1,
      outlineColor: Cesium.Color.BLACK,
      horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
      pixelOffset: new Cesium.Cartesian2(0.0, -10),
      pixelOffsetScaleByDistance: new Cesium.NearFarScalar(
        1.5e2,
        3.0,
        1.5e7,
        0.5
      ),
    },
  });
  return
}

function removeStationDataList (viewer) {
  viewer.dataSources.remove(stationDataListEntityCollection)
  stationDataListEntityCollection = null
}

export { addStationDataList, removeStationDataList }